import * as Yup from 'yup';
import { useSnackbar } from 'notistack';
import { useState, useEffect } from 'react';
import { Icon } from '@iconify/react';
import closeFill from '@iconify/icons-eva/close-fill';
// material
import {
  Box,
  Backdrop,
  Paper,
  Typography,
  Stack,
  TextField,
  Alert,
  CircularProgress,
  MenuItem
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
//
import Scrollbar from 'components/Scrollbar';

import { Form, FormikProvider, useFormik, FormikState } from 'formik';
// redux
import { RootState, useSelector, useDispatch } from 'redux/store';
import ImageCropDialog from './ImageCropDialog';
import { render } from 'nprogress';
import { MIconButton } from 'components/@material-extend';
import { updateUserProfileImage } from 'redux/slices/user';
import useAuth from 'hooks/useAuth';
import axios from 'axios';
import { isValidToken } from 'utils/jwt';
import { isValid } from 'date-fns';
// ----------------------------------------------------------------------

const DRAWER_WIDTH = 360;

type TeacherFormProps = {
  openform: boolean;
  formClosed: VoidFunction;
};

type FormState = {
  photo: File | null;
};

export default function ProfileForm({ openform, formClosed }: TeacherFormProps) {
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { user } = useAuth();
  console.log('User', user);
  const [alertError, setAlertError] = useState('');
  const { error: userErrro, response: userResponse } = useSelector(
    (state: RootState) => state.user
  );

  useEffect(() => {
    setOpen(openform);
  }, [openform]);

  useEffect(() => {
    console.log('USerResponse', userResponse);
    if (userResponse && userResponse.type === 'UPDATE_USER_IMAGE_SUCCESS') {
      enqueueSnackbar('Update success', {
        variant: 'success',
        action: (key) => (
          <MIconButton size="small" onClick={() => closeSnackbar(key)}>
            <Icon icon={closeFill} />
          </MIconButton>
        )
      });

      handleClose();
    }
  }, [userResponse]);
  //   useEffect(() => {
  //     if (
  //       teacherResponse &&
  //       (teacherResponse.type === 'CREATE_TEACHER_SUCCESS' ||
  //         teacherResponse.type === 'UPDATE_TEACHER_SUCCESS')
  //     ) {
  //       enqueueSnackbar(teacherID ? 'Update success' : 'Create success', {
  //         variant: 'success',
  //         action: (key) => (
  //           <MIconButton size="small" onClick={() => closeSnackbar(key)}>
  //             <Icon icon={closeFill} />
  //           </MIconButton>
  //         )
  //       });

  //       handleClose();
  //     }
  //   }, [teacherResponse]);

  const handleClose = () => {
    setOpen(false);
    setAlertError('');
    formik.resetForm({
      values: {
        photo: ''
      }
    });
    formClosed();
  };

  const FormSchema = Yup.object().shape({
    photo: Yup.mixed()

      .test('fileType', 'Unsupported File Format', function (value) {
        if (!value) return true;
        const supportedFormats = ['image/jpg', 'image/jpeg', 'image/png'];
        return supportedFormats.includes(value.type);
      })
      .test('fileSize', 'File size is too large (max 2MB)', function (value) {
        if (!value) return true;
        const maxSize = 2 * 1024 * 1024;
        return value.size <= maxSize;
      })
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      photo: user?.photo || ''
    },
    validationSchema: FormSchema,
    onSubmit: async (values, { setSubmitting, resetForm, setErrors }) => {
      try {
        const formData = new FormData();
        if (values.photo && typeof values.photo !== 'string') {
          formData.append('photo', values.photo);
          const userId: any = user?.id || '';
          await dispatch(updateUserProfileImage(userId, formData));
        }

        handleClose();
        window.location.reload();
      } catch (error: any) {
        console.error(error);
        setSubmitting(false);
        setErrors(error);
      }
    }
  });
  const [cropModalOpen, setCropModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const handleFileChange = (event: any) => {
    const file = event.currentTarget.files?.[0];
    if (file) {
      formik.setFieldValue('photo', file);
      const reader = new FileReader();
      reader.onload = () => {
        const imageData = reader.result as string;
        setSelectedImage(imageData);
        setCropModalOpen(true);
      };

      reader.readAsDataURL(file);
    }
  };

  const handleCropComplete = (croppedBlob: Blob) => {
    const croppedFile = new File([croppedBlob], 'cropped.jpg', { type: 'image/jpeg' });
    formik.setFieldValue('photo', croppedFile);
  };

  const { errors, touched, handleSubmit, isSubmitting, getFieldProps } = formik;

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Backdrop
          sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={open}
          onClick={handleClose}
        />

        <Box
          sx={[
            {
              top: 0,
              bottom: 0,
              right: 0,
              position: 'fixed',
              zIndex: 2001,
              ...(open && { right: 0 })
            },
            (theme) => ({
              [theme.breakpoints.down('sm')]: {
                top: '70px'
              }
            })
          ]}
        >
          <Paper
            sx={{
              height: 1,
              width: '0px',
              overflow: 'hidden',
              borderRadius: 0,
              boxShadow: (theme) => theme.customShadows.z24,
              transition: (theme) => theme.transitions.create('width'),
              ...(open && { width: DRAWER_WIDTH })
            }}
          >
            <Backdrop
              sx={{
                color: '#fff',
                zIndex: (theme) => theme.zIndex.drawer + 1,
                position: 'absolute'
              }}
              open={isLoading}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ py: 2, pr: 1, pl: 2.5 }}
            >
              <Typography variant="subtitle1">Update Profile</Typography>
              <MIconButton onClick={handleClose}>
                <Icon icon={closeFill} width={20} height={20} />
              </MIconButton>
            </Stack>

            <Scrollbar sx={{ height: 1 }}>
              <Stack spacing={4} sx={{ pt: 3, px: 3, pb: 15 }}>
                <Stack spacing={1.5}>
                  {alertError && <Alert severity="error">{alertError}</Alert>}

                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                    <TextField
                      fullWidth
                      type="file"
                      variant="filled"
                      inputProps={{ accept: 'image/*' }}
                      onChange={handleFileChange}
                      error={Boolean(touched.photo && errors.photo)}
                      helperText={touched.photo && errors.photo}
                    />

                    {selectedImage && (
                      <ImageCropDialog
                        open={cropModalOpen}
                        imageSrc={selectedImage}
                        onClose={() => setCropModalOpen(false)}
                        onCropComplete={handleCropComplete}
                      />
                    )}
                  </Stack>
                </Stack>

                <Stack spacing={1.5}>
                  <LoadingButton
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                    loading={isSubmitting}
                  >
                    Update Profile
                  </LoadingButton>
                </Stack>
              </Stack>
            </Scrollbar>
          </Paper>
        </Box>
      </Form>
    </FormikProvider>
  );
}
